import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the app. Defaults:
 *   - 1 min staleTime keeps the home XP/streak panel snappy; we invalidate
 *     the relevant queries after a completion mutation anyway.
 *   - Retries off for writes (offline queue handles that).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
